import React, { useState, useCallback, useRef } from 'react';
import './AdminToast.css';

const TOAST_ICONS = {
  success: '✓',
  error: '✕',
  info: 'ℹ',
  warning: '⚠',
};

export function useAdminToast() {
  const [toasts, setToasts] = useState([]);
  const timersRef = useRef({});

  const dismissToast = useCallback((id) => {
    setToasts((prev) => prev.map((t) => (t.id === id ? { ...t, exiting: true } : t)));
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
      delete timersRef.current[id];
    }, 280);
  }, []);

  const showToast = useCallback((message, type = 'success', duration = 4200) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    setToasts((prev) => [...prev, { id, message, type, exiting: false }]);

    if (timersRef.current[id]) clearTimeout(timersRef.current[id]);
    timersRef.current[id] = setTimeout(() => dismissToast(id), duration);

    return id;
  }, [dismissToast]);

  return { toasts, showToast, dismissToast };
}

const AdminToast = ({ toasts, onDismiss }) => {
  if (!toasts.length) return null;

  return (
    <div className="admin-toast-container" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`admin-toast admin-toast--${toast.type} ${toast.exiting ? 'admin-toast--exit' : ''}`}
          role="status"
        >
          <span className="admin-toast-icon" aria-hidden>
            {TOAST_ICONS[toast.type] || TOAST_ICONS.info}
          </span>
          <p className="admin-toast-message">{toast.message}</p>
          <button
            type="button"
            className="admin-toast-close"
            onClick={() => onDismiss(toast.id)}
            aria-label="Bezárás"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default AdminToast;
